const courses = state => state.courses.list;
const course = state => state.courses.course;
const article = state => state.courses.article;

export default {
  courses,
  course,
  article,
};
